import { AnonymousFeedbackForm } from "../Form/AnonymousFeedbackForm";
import { LabelButton } from "../buttons/LabelButton/LabelButton";
import "./formSections.css";

export const AnonymousFeedbackSection = () => {
  return (
    <div className="feedback">
      <div className="feedback-left-side">
        <LabelButton>GET IN TOUCH</LabelButton>
        <div className="yields">
          <p className="description-medium">
            If you would like to provide us with any information, please fill
            out the form.
          </p>
        </div>
      </div>
      <AnonymousFeedbackForm />
    </div>
  );
};
